// extracted by mini-css-extract-plugin
export default {"root":"_3u-FjouaHfLuJ_n2cj6JK9"};